/**
 * WalkthroughEntry — client view of a "Model walkthrough" Client Hub entry (Matt, 2026-10-15).
 * An optional lead-in note and a "Walk the model" button that opens the 3D viewer on the model as
 * it stood when the team released this entry (/walk?hub=<walkToken>, the same full viewer the
 * consultant backgrounds use: orbit, cut, walk, fly). Releasing happens server-side when the entry
 * is published (api/_walkthroughRelease.js); until then there is no token and the card says so.
 */
import Markdown from '../../components/Markdown.jsx'
import { J } from '../journeyUI.jsx'

export default function WalkthroughEntry({ entry, token }) {
  const d = entry.data || {}
  // &j= tells the walk page who is walking, so the project channel hears when they go in and out
  const href = d.walkToken ? '/walk?hub=' + encodeURIComponent(d.walkToken) + (token ? '&j=' + encodeURIComponent(token) : '') : null
  const when = d.releasedAt
    ? new Date(d.releasedAt).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'America/Los_Angeles' })
    : ''
  return (
    <div>
      <div style={J.eyebrow}>3D model</div>
      <h2 style={J.title}>{entry.title || 'Walk the model'}</h2>
      <hr style={J.rule} />
      {d.intro && <div style={{ ...J.body, marginBottom: 18 }}><Markdown text={d.intro} /></div>}
      {href ? (
        <>
          <a href={href} target="_blank" rel="noopener noreferrer" style={cta}>Walk the model</a>
          <div style={{ ...J.body, fontSize: 12.5, color: '#7a9aaa', marginTop: 14 }}>
            {when ? 'The model as it stood on ' + when + '. ' : ''}
            Opens in a new tab. Turn and zoom around the outside, then step inside and walk through it. Works on a phone or tablet too.
          </div>
        </>
      ) : (
        <div style={{ ...J.body, fontStyle: 'italic', color: '#7a9aaa' }}>This is being prepared.</div>
      )}
    </div>
  )
}

const cta = { display: 'inline-block', fontFamily: '"DM Sans", sans-serif', fontSize: 14, fontWeight: 600, color: '#fff', background: '#07272D', border: 'none', borderRadius: 6, padding: '12px 26px', cursor: 'pointer', textDecoration: 'none' }
